// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-batch-modal-dialog[data-v-9507b74a] {\n  width: 1074px;\n  margin: auto;\n}\n.select-file-button[data-v-9507b74a] {\n  width: 178px;\n}\n.overwritten-alert[data-v-9507b74a] {\n  background-color: rgba(246, 170, 28, 0.3);\n  display: flex;\n  padding: 0.625rem;\n  align-items: center;\n  border-radius: 5px;\n  color: #000;\n  margin-top: 1rem;\n}\n.overwritten-alert > svg[data-v-9507b74a] {\n  margin-right: 0.625rem;\n}", ""]);
// Exports
module.exports = exports;
